<template>

    <Page>

        <ImageAndText 
            animation="zoom"
            src="/WorkOrders/contract-creation.png"
            image-class="rounded-xl ring-4 ring-black"
            floor-shadow>

            <h2 class="mb-4">Contract Creation</h2>
            <ul class="mt-3 list-disc pl-6 font-normal text-white/80">
                <li>Contracts are created in the Carbucks Carparc Application</li>
                <li>Customer and Vehicles details are copied over automatically from the DMS</li>
                <li>Contracts are presented to the customer who accepts the terms &amp; conditions directly on their phone</li>
            </ul>

        </ImageAndText>


    </Page>


</template>